import { Component } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { APPCONFIG } from '../../../config';
import { Http,Headers } from '@angular/http';
import { IcbService } from '../../icb.service'
import { ErrorHandler } from '../../../shared/services/error-handler.service'
import { HttpService } from '../../../shared/services/http.service'
import { LayoutService } from '../../../layout/layout.service'
import { SessionHandler } from '../../../shared/services/session-handler.service';
import { CommonService } from '../../../shared/services/common.service';
import { FormGroup, FormBuilder, FormControl, Validators,FormsModule  } from '@angular/forms';
import { itemClass,itemClassEdit } from './itemClass';
import { MdDialog,MdDialogRef } from '@angular/material';
import { dialogComponent } from '../../../dialog/dialog.component';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';


@Component({
    selector: 'request-add',
    template: require('./summary.component.html'),
    styles: [require('./summary.component.scss')],
    providers: [HttpService, ErrorHandler,SessionHandler,IcbService]
})

export class t2cSummaryComponent {		
    t2cFormData:any= {};
    dialogRef;
    requestFormData:any = {};
    userData:any;
    tradeId:any;
    tradeData:any = {};
    uploadedDocList: any = [];
    doc: any;

	constructor(private router: Router,private route: ActivatedRoute,private Http: Http,private http:HttpService,private formBuilder: FormBuilder, private commonService : CommonService,private sessionHandler:SessionHandler,
    private dialog: MdDialog) {

        if(this.http.checkSession()){
            this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
            this.tradeId = this.userData.tradePartnerId;
            let data = this.commonService.getData();
            if(data && data['icbRequest']) {
                this.t2cFormData = data['icbRequest'];
                console.log(this.t2cFormData)
            } else {
                this.router.navigateByUrl('/app/icb/consumer/data');
            }
        } else {
            this.http.showSessionError();
        }
    }

    ngOnInit() {

        this.uploadedDocList= this.commonService.getIcbImageData()
        console.log(this.uploadedDocList);
       // console.log(this.commonService.getIcbImageData())
        //this.uploadedDocList=

    }

    public goToNextPage() {
        console.log(this.commonService.getIcbImageData())

        this.t2cFormData['fileUrlsDTO']=this.commonService.getIcbImageData();
        // "serviceOrder/v1/saveServiceOrderWithSap" // **old one
        this.http.postRequest(this.t2cFormData,'serviceOrder/v1/saveServiceOrderWithSap').subscribe(
            res => {
                this.saveResponse(res);
            },
            err => {
                if(err && err.status!=0){
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = 'Submit Failed';

                }
                this.http.onEnd();
                }
            );
    }
    public saveResponse(res) {
        
        if(res.status == 'Success') {
            this.t2cFormData['soId'] = res.ServiceOrderId;
            this.t2cFormData['isOutOfWarranty'] = res.isOutOfWarranty;
            this.commonService.setData(this.t2cFormData);
            this.router.navigateByUrl('/app/icb/consumer/confirm');
            this.commonService.clearIcbImageData();
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = res.errorMessage;
        }
        this.http.onEnd();
    }

    public goToPreviousPage() {
        this.router.navigateByUrl('/app/icb/consumer/data');
    }


    navigateDocLink(docUrl) {
        this.dialogRef = null;
        this.dialogRef = this.dialog.open(ViewDocDialog);
        this.dialogRef.componentInstance.urlList = docUrl;
        console.log(this.dialogRef.componentInstance.urlList);
        this.http.onEnd();
      }
}


@Component({
    selector: 'view-doc',
    template: require('./view-doc.component.html'),    
    providers: [HttpService, SessionHandler]
  })
  export class ViewDocDialog {
    //url: string = "https://storage.googleapis.com/kitchenaid-web-return-dev.appspot.com/ReturnUploadedDocs/challan_receipt.pdf";
    urlSafe: SafeResourceUrl;
    urlList: any = [];
    safeUrlList: any = [];
    constructor(public dialog: MdDialog, private commonService: CommonService, public sanitizer: DomSanitizer) { }
    ngOnInit(): void {
      //this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    }
  
    public fullView(docUrl) {
      window.open(docUrl, "_blank");
    }
  
    public closeDialog() {
      this.dialog.closeAll();
    }
  
  }


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/icb/t2c/summary/summary.component.ts